import React from "react";

const date = new Date();
const year = date.getFullYear();

function Footer() {
  return <footer>{/* <p>© {year} Surajv311</p> */}</footer>;
}

export default Footer;
